import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ComponentOptions, Slot } from 'vue';

interface Props {
  is?: string | ComponentOptions;
  first?: number;
  last?: number;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    is: { default: 'div' },
    first: { default: 6 },
    last: { default: 4 }
  },
  setup(__props: any) {

const props = __props as { is: string | ComponentOptions, first: number, last: number }


const mask = (slot?: Slot) => {
  if (!slot) return slot;
  const text = slot()[0].children;
  if (typeof text !== 'string') return '';
  if (text.length < props.first || text.length < props.last) return '';
  return (
    text.slice(0, props.first) + '...' + text.slice(slot.length - props.last)
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.is), null, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(mask(_ctx.$slots.default)), 1)
    ]),
    _: 1
  }))
}
}

})